export function percentToNumber (percent) {
  return Number.parseFloat(percent) / 100
}
